import React, { useEffect, useState } from "react";
import { adminApi } from "../../lib/adminAuth";
import { Beer, Bone, Map, MessageSquareText, Users, TrendingUp } from "lucide-react";

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    adminApi.dashboard().then(setData).catch((e) => setErr(e?.response?.data?.detail || "Error cargando dashboard"));
  }, []);

  if (err) return <div className="text-red-400 font-mono">{err}</div>;
  if (!data) return <div className="font-mono text-xs uppercase tracking-widest text-[#A3A3A3]">Cargando…</div>;

  const cards = [
    { label: "Locales", value: data.venues, icon: Map },
    { label: "Huesos activos", value: `${data.coupons_active}/${data.coupons_total}`, icon: Bone },
    { label: "Reclamos totales", value: data.claims_total, icon: TrendingUp },
    { label: "Tasa de reclamo", value: `${data.redemption_rate}%`, icon: TrendingUp },
    { label: "Reseñas", value: data.reviews, icon: MessageSquareText },
    { label: "Check-ins", value: data.checkins, icon: Beer },
  ];

  return (
    <div data-testid="admin-dashboard-page" className="space-y-8">
      <header>
        <div className="font-mono text-[10px] uppercase tracking-widest text-[#FEBA01]">Panel</div>
        <h1 className="font-display text-4xl uppercase tracking-tight">Dashboard</h1>
        <p className="text-sm text-[#A3A3A3] mt-1">Vista general de la actividad en Kiltro Scout.</p>
      </header>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {cards.map((c) => (
          <div key={c.label} className="bg-[#1A1A1A] border-2 border-[#333] p-4 hover:border-[#FEBA01] transition" data-testid={`stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="flex items-center gap-2">
              <c.icon size={14} className="text-[#FEBA01]" />
              <div className="font-mono text-[10px] uppercase tracking-widest text-[#A3A3A3]">{c.label}</div>
            </div>
            <div className="mt-2 font-display text-3xl text-white">{c.value}</div>
          </div>
        ))}
      </div>

      <section>
        <h2 className="font-display text-2xl uppercase tracking-tight mb-3 flex items-center gap-2">
          <TrendingUp size={20} className="text-[#FEBA01]" /> Top locales · Últimos 30d
        </h2>
        {data.top_venues.length === 0 ? (
          <div className="border-2 border-dashed border-[#333] p-6 text-center font-mono text-xs uppercase tracking-widest text-[#A3A3A3]">
            Sin actividad en los últimos 30 días.
          </div>
        ) : (
          <div className="bg-[#1A1A1A] border-2 border-[#333] divide-y divide-[#333]">
            {data.top_venues.map((v, i) => (
              <div key={v.venue_id} className="flex items-center justify-between px-4 py-3">
                <div className="flex items-center gap-3">
                  <div className="font-display text-2xl text-[#FEBA01] w-8">{i + 1}</div>
                  <div className="font-display uppercase">{v.venue_name}</div>
                </div>
                <div className="font-mono text-xs uppercase tracking-widest text-[#A3A3A3]">
                  {v.count} check-ins
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      <section>
        <h2 className="font-display text-2xl uppercase tracking-tight mb-3 flex items-center gap-2">
          <Users size={20} className="text-[#FEBA01]" /> Top reseñadores
        </h2>
        {data.top_reviewers.length === 0 ? (
          <div className="border-2 border-dashed border-[#333] p-6 text-center font-mono text-xs uppercase tracking-widest text-[#A3A3A3]">
            Sin reseñas todavía.
          </div>
        ) : (
          <div className="bg-[#1A1A1A] border-2 border-[#333] divide-y divide-[#333]">
            {data.top_reviewers.map((r) => (
              <div key={r.handle} className="flex items-center justify-between px-4 py-3">
                <div className="font-display uppercase">{r.handle}</div>
                <div className="font-mono text-xs uppercase tracking-widest text-[#A3A3A3]">
                  {r.reviews} reseñas · {r.helpful} útiles
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
